import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure


const HealthRisksConventionalPads = () => {
  useMetaTags({
    title: "Health Risks of Conventional Sanitary Pads: What You Need to Know",
    description: "Learn about the hidden health risks of conventional sanitary pads, including harmful chemicals, skin irritation, and endocrine disruption. Discover safer alternatives.",
    keywords: "health risks of sanitary pads, harmful chemicals in pads, dioxins in sanitary pads, organic menstrual products, safe period care",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/health-risks-of-conventional-sanitary-pads",
    ogTitle: "Health Risks of Conventional Sanitary Pads: What You Need to Know",
    ogDescription: "Conventional pads may contain toxic chemicals that pose serious health risks. Find out how to protect your menstrual health with safer alternatives.",
    ogImage: "https://images.unsplash.com/photo-1712842955521-55c8c01ef148?w=600",
    ogUrl: "https://organicpads.shop/health-risks-of-conventional-sanitary-pads",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Are Conventional Sanitary Pads Safe? Understanding the Health Risks",
    twitterDescription: "Discover the hidden health risks of conventional pads, including harmful chemicals and skin irritation, and explore safer alternatives.",
    twitterImage: "https://images.unsplash.com/photo-1712842955521-55c8c01ef148?w=600",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

   const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/health-risks-of-conventional-sanitary-pads"
    },
    "headline": "Health Risks of Conventional Sanitary Pads: What You Need to Know",
    "description": "Learn about the hidden health risks of conventional sanitary pads, including harmful chemicals, skin irritation, and endocrine disruption. Discover safer alternatives.",
    "image": "https://images.unsplash.com/photo-1712842955521-55c8c01ef148?w=600",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "health risks of sanitary pads",
      "harmful chemicals in pads",
      "dioxins in sanitary pads",
      "organic menstrual products",
      "safe period care"
    ]
  }
  

  return (
    <>
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        Understanding the Health Risks of Conventional Sanitary Pads
      </h1>
      <img
        src="https://images.unsplash.com/photo-1712842955521-55c8c01ef148?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8b3JnYW5pYyUyMHNhbml0YXJ5JTIwcGFkc3xlbnwwfHwwfHx8MA%3D%3D"
        alt="Health Risks"
        className="w-full rounded-lg mb-4"
      />
      <p className="text-gray-700 mb-4">
        Conventional sanitary pads contain numerous harmful chemicals and synthetic materials
        that can pose serious risks to your health. From toxic dioxins to artificial fragrances,
        these everyday products might be silently impacting your wellbeing in ways you haven't considered.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Major Health Concerns</h2>
      <ul className="list-disc list-inside text-gray-700 mb-4">
        <li>Exposure to harmful chemical dioxins</li>
        <li>Risk of endocrine disruption</li>
        <li>Potential allergic reactions</li>
        <li>Skin irritation and rashes</li>
        <li>Reproductive health concerns</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">How to Protect Your Health?</h2>
      <p className="text-gray-700 mb-4">
        Look for pads with <strong>natural certification</strong> and avoid products containing
        artificial fragrances, chlorine bleach, and synthetic materials. Your intimate health
        deserves the best care possible.
      </p>
      <img
        src="https://plus.unsplash.com/premium_photo-1702598576513-fe7425ebf6bd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG9yZ2FuaWMlMjBzYW5pdGFyeSUyMHBhZHN8ZW58MHx8MHx8fDA%3D.jpg"
        alt="Natural Protection"
        className="w-full rounded-lg mb-4"
      />

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Final Thoughts</h2>
      <p className="text-gray-700 mb-4">
        Your menstrual health is too important to compromise.
        <strong> Choose safer alternatives for better health!</strong>
      </p>
    </div>
      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default HealthRisksConventionalPads;
